import AirlinesIcon from "@mui/icons-material/Airlines";
import { useSelector } from "react-redux";
import { selectors as airlinesSelectors } from "../../redux/airlines";
import BaseTag from "./BaseTag";

const AirlineTag = (props) => {
  const entity = useSelector((state) =>
    airlinesSelectors.selectById(state, props.value),
  );
  return (
    <BaseTag
      icon={<AirlinesIcon />}
      label={`(${entity?.iata}) ${entity?.name}`}
    />
  );
};

export default AirlineTag;
